import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Report_Tile_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_REPORTTILE_ID:   {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Id',              columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    REPORT_ID:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Report Id',          columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    REPORT_NAME:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Report Name',        columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    REPORT_DESCRIPTION: {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Report Description', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    REPORT_TYPE_ID:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Type Id',            columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    REPORT_KEYWORDS:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Keywords',           columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SHARED_IND:         {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Shared Ind',         columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1}},
    WB_AUTHUSR_ID:      {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB User Id',         columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    AUTHUSR_NAME:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'User Name',          columnResourceName: 'colAuthUserName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_CONNECTION_ID:   {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Connection Id',   columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CONNECTION_NAME:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Connection Name',    columnResourceName: 'colAuthUserName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT_ORDER:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Sort Order',         columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    TREE_PATH:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Tree Path',          columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const ReportSearchProviderBasic: ISearchProvider = {

  keyFields: {id:    'WB_REPORTTILE_ID',
              id_ui: 'REPORT_ID',
              name:  'REPORT_NAME'},

  searchProviderFields: vUI_Report_Tile_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Report_Tile_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const ReportSearchProfileByName: ISearchProfile = {
  profileId: "default",
  profileName: "Id, Name",
  renderOptions: { ui5ResourceId: "ReportSearchProfileByName" },

  profileFilter: [
    {profileFilterName: 'Id',     searchProviderFieldId: 'REPORT_ID',   renderOptions: { }},
    {profileFilterName: 'Name',   searchProviderFieldId: 'REPORT_NAME', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'REPORT_NAME','REPORT_DESCRIPTION','CONNECTION_NAME','AUTHUSR_NAME','REPORT_KEYWORDS','REPORT_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
  ],

  profileSearchProvider: ReportSearchProviderBasic,

  profileTreeIdDefault: "default",
  profileTrees: [
    {treeId: "default",
     treeName: "By Folder Hierarchy",
    nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
    renderOptions: {ui5: {leafIcon: "sap-icon://kpi-corporate-performance" }}},
    {treeId: "owner",
      treeName: "By Creator",
      nodeProviders: [new ColumnNodeProvider(['AUTHUSR_NAME'], {defaultValues: "Creator not set", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {ui5: {leafIcon: "sap-icon://kpi-corporate-performance" }}}

  ],

  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}


const ReportTileSearch: ISearch = {
  searchName: "Select Workspace Item (s)",
  renderOptions: { ui5ResourceId: "ReportSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: [ReportSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("ReportTileBO", "ReportTile", ReportTileSearch, "Report Tile Search")

export {ReportTileSearch}
